import React, { useContext } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  useMediaQuery,
} from "@mui/material";
import { withStyles } from "@mui/styles";
import { AppContext } from "./utils";

const StyledModal = withStyles(() => ({
  root: {
    "& .MuiDialog-root": {
      zIndex: "1301 !important",
    },
    "&.MuiDialog-container": {
      overflowY: "hidden !important",
    },
    "& .MuiDialog-paperScrollPaper": {
      backgroundColor: "tranparent !important",
      height: "auto",

      boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
      // borderRadius: "30px !important",
    },
    "& .dialoge__content__section": {
      background: "#251542",
      // border: "1px solid #f1f5f91f",
      // borderRadius: 5,
    },
    "& .MuiDialogContent-root": {
      padding: "0px",
    },
  },
}))(Dialog);

function LogoutModal({ openLogout, setopenLogout }) {
  const { account, connect, disconnect } = useContext(AppContext);
  const matches = useMediaQuery("(max-width:760px)");
  const handleClose = () => {
    setopenLogout(false);
  };

  return (
    <>
      <StyledModal
        keepMounted
        open={openLogout}
        onClose={handleClose}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogContent className="dialoge__content__section">
          <div
            style={{
              textAlign: "center",
              paddingBottom: "30px",
              width: matches ? "auto" : "500px",
              background: "#8F2051",
            }}
          >
            <Box
              style={{
                background: "#251442",
              }}
              display="flex"
              px={2}
              py={2}
              justifyContent="space-between"
            >
              <Box
                color={"white"}
                fontSize="20px"
                textAlign="left"
                fontWeight="600"
                fontFamily="Segoe UI"
              >
                Your Wallet
              </Box>
              <Box>
                <i
                  onClick={handleClose}
                  style={{ color: "white", cursor: "pointer" }}
                  class="fa-solid fa-xmark"
                ></i>
              </Box>
            </Box>
            <Box mt={2}>
              <img width="100px" src="/logo.png" alt="" />
            </Box>
            <Box
              px={2}
              borderRadius="10px"
              color="#ffffff"
              fontSize={matches ? "12px" : "17px"}
              textAlign="center"
              fontWeight={matches ? "400" : "600"}
              fontFamily="Segoe UI"
            >
              {account}
            </Box>

            <Box display="flex" justifyContent="center">
              <Button
                onClick={() => {
                  disconnect();
                  handleClose();
                }}
                sx={{
                  marginTop: "34px",
                  background: "#CF1B52",
                  color: "white",
                  borderRadius: "30px",
                  padding: "12px 34px",
                  zIndex: "999",
                  fontFamily: "'Baloo Bhai 2', cursive",
                }}
              >
                logout
              </Button>
            </Box>
          </div>
        </DialogContent>
      </StyledModal>
    </>
  );
}
export default LogoutModal;
